<template>
    <div class="overlay">
        <div>
            <div class="modal_box wd720">
                <div class="modal_header_unit">
                    <div class="modal_header_box">
                        <p class="modal_header_tit_s"> </p>
                        <p class="modal_header_tit">パスワード変更</p>
                    </div>
                    <div class="modal_header_left">
                        <router-link class="js-modal-close" :to="{ name: 'top' , params: { brandPath: $route.params.brandPath}} ">戻る</router-link>
                    </div>
                </div>
                <div class="modal_content_tex">
                    <p>パスワードを変更してください。</p>
                </div>
                <div class="modal_password_setting_box">
                    <div class="modal_password_box wd512 border-0">
                        <div class="form-group form-row">
                            <label class="col-form-label col-sm-6 text-left" for="current"><img class="required" src="../assets/required.png" />現在のパスワード</label><input id="current" class="form-control col-sm-6" type="password" v-model="currentPassword">
                        </div>
                        <div class="form-group form-row">
                            <label class="col-form-label col-sm-6 text-left" for="new"><img class="required" src="../assets/required.png" />新しいパスワード</label><input id="new" class="form-control col-sm-6" type="password" v-model="password">
                        </div>
                        <div class="form-group form-row">
                            <label class="col-form-label col-sm-6 text-left" for="confirm"><img class="required" src="../assets/required.png" />新しいパスワード（確認）</label><input id="confirm" class="form-control col-sm-6" type="password" v-model="passwordConfirm">
                        </div>
                    </div>
                    <div class="modal_password_box wd512 border-0">
                        <label>パスワードは、8桁以上128桁以内かつ半角英数記号(!"#$%&'()*+,-./:;&lt;=&gt;?@[]^_`{|}~)で入力してください。</label>
                    </div>
                    <p class="text-danger text-center text_white_space_pre_wrap">{{updateError}}</p>
                    <div class="btn_submit">
                        <a role="button" @click.prevent.stop="submit">OK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PasswordSetting',
        data: function () {
            return {
                currentPassword: null,
                password: null,
                passwordConfirm: null,
                updateError: null,
                brandId: null,
                redirect: null,
            }
        },
        created: function () {
            this.brandId = this.$store.getters['manager/brandId']
            this.redirect = this.$route.query.redirect

            if (this.brandId === null || this.redirect === null) {
                let error = {
                    message: 'トップに戻ってもう一度ログインしてください。',
                    button: {
                        path: {name: 'top', params: {brandPath: this.$route.params.brandPath}}
                    }
                }
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
        },
        methods: {
            validateRequired: function () {
                if (! this.currentPassword) {
                    return { result: false, mes: '現在のパスワードを入力してください。' }
                }
                if (! this.password) {
                    return { result: false, mes: '新しいパスワードを入力してください。' }
                }
                if (! this.passwordConfirm) {
                    return { result: false, mes: '新しいパスワード(確認)を入力してください。' }
                }
                return { result: true }
            },
            submit: async function () {
                this.updateError = ''

                // 画面側バリデーション実行
                const validation = this.validateRequired()
                if (! validation.result) {
                    this.updateError = validation.mes
                    return
                }

                const url = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/password_update'
                try {
                    await this.$axios.post(url, {
                        current_manager_password: this.currentPassword,
                        new_manager_password: this.password,
                        new_manager_password_confirm: this.passwordConfirm,
                    })

                } catch (error) {
                    if (error.customError) {
                        this.updateError = error.customError.message
                    } else {
                        this.updateError = error.message
                    }
                }

                if (this.updateError == '') {
                    this.$store.dispatch('manager/setPasswordInitFlg', false)
                    this.$router.replace(this.redirect)
                }
            }
        }
    }
</script>
